import {formatString} from '@optimaxdev/utils';

export const ENDPOINTS = {
    ADD_COUPON: 'optimaxcart/react/applyCoupon',
    ADD_TO_CART_V2: 'api/rest/optimaxcheckout/v2/cart/items',
    ADDRESSES_GET: 'optimaxcheckout/address/getAddresses',
    ADDRESSES_GET_FROM_QUOTE: 'optimaxcheckout/address',
    ADDRESSES_REMOVE: 'optimaxcheckout/address/remove',
    ADDRESSES_SAVE: 'optimaxcheckout/address/save',
    AMAZON_SESSION: 'payment/amazon/session',
    AMAZON_SESSION_INFO: formatString.bind(null, 'payment/amazon/session/{{checkoutSessionId}}'),
    BIND_EXAM: 'exam/exam/bind',
    CART_ADD_UPSELL: 'optimaxcart/react/addOption',
    CART_GET_ACCESSORIES: 'api/rest/accessories',
    CART_GET_BANNER: 'optimaxcart/react/getBanner',
    CART_GET_PAYMENT_BUTTONS: 'optimaxcart/payments/getButtons',
    CART_GET_TOTALS: '/api/rest/optimaxcheckout/v2/regular/cart/totals',
    CART_PUT_GET_QUOTE_ITEM_V2: 'api/rest/optimaxcheckout/v2/cart/item',
    CART_PUT_MOVE_QUOTE_ITEM_V2: formatString.bind(
        null,
        `optimaxcart/react/moveItem/quoteType/{{quoteType}}/id/{{quoteItemId}}`,
    ),
    CART_PUT_QUOTE_TYPE_ITEM: formatString.bind(
        null,
        `api/rest/optimaxcheckout/v2/{{quoteType}}/cart/item/{{quoteItemId}}`,
    ),
    CART_REMOVE_QUOTE_ITEMS: formatString.bind(
        null,
        `api/rest/optimaxcheckout/v2/{{quoteType}}/cart/items`,
    ),
    CART_REMOVE_UPSELL: 'optimaxcart/react/removeOption',
    CART_REORDER: 'api/rest/optimaxcheckout/v2/cart/direct',
    CHECK_ORDER: '/api/rest/optimaxcheckout/v2/cart/checkorder',
    CHECKOUT_GET_APPLE_CLIENT_SECRET: 'optimaxcheckout/payment/paymentintent',
    CHECKOUT_GET_ITEMS_V2: 'api/rest/optimaxcheckout/v2/cart/items',
    CHECKOUT_GET_NEXT_DAY: '/api/rest/shipping/nextday',
    CHECKOUT_GET_PAYMENTS: 'optimaxcheckout/payment',
    CHECKOUT_GET_SHIPPING: 'optimaxcheckout/shipping',
    CHECKOUT_GET_SHIPPING_REGION: 'optimaxcheckout/address/getRegion',
    CHECKOUT_GET_TOTALS_V2: 'api/rest/optimaxcheckout/v2/cart/totals',
    CHECKOUT_ONE_STEP: '/api/rest/optimaxcheckout/one-step-availability',
    CHECKOUT_PLACE_ORDER: 'checkout/onepage/saveOrder',
    CHECKOUT_PLACE_ORDER_PAYPAL: 'optimaxpaypal/order/place',
    CHECKOUT_PLACE_ORDER_V2: '/api/rest/optimaxcheckout/v2/saveorder',
    CHECKOUT_SET_PAYMENT: 'optimaxcheckout/payment/save',
    CHECKOUT_SET_SHIPPING: 'api/rest/optimaxcheckout/v2/regular/cart/shipping',
    COUNTRIES_GET: 'directory/country',
    CREATE_KLARNA_SESSION: 'payment/klarna/session',
    CREATE_TRANSITIONAL: 'newsletter/v2/email/transitional',
    CUSTOMER_ADDRESS: 'customer/address',
    CUSTOMER_GET: 'customer/api/current',
    CUSTOMER_GET_ORDER: 'api/rest/sales/order',
    CUSTOMER_REFID: '/cordial/contact/refId',
    DEACTIVATE: 'newsletter/v2/subscription/deactivate',
    EXAM: 'api/rest/v2/order/last/item/exam',
    FETCH_ALGOLIA_ANALYTICS: 'bff/algolia/analytics',
    FETCH_DY_ANALYTICS: 'bff/dynamicYield/analytics',
    FETCH_TRUSTPILOT_RATING: 'bff/trustpilot/rating',
    GENERATE_ONE_TIME_COUPON: formatString.bind(null, `/api/rest/typ/coupon/{{orderId}}`),
    GET_ADDRESSES: 'optimaxcheckout/address/getAddresses',
    GET_ADDRESSES_FROM_ORDER: formatString.bind(
        null,
        'api/rest/optimaxcheckout/v2/cart/address/{{token}}',
    ),
    GET_CART_ITEMS_V2: 'api/rest/optimaxcheckout/v2/cart/items',
    GET_CL_SUBSCRIPTION_PLANS: formatString.bind(null, 'subscription/product/{{id}}/plans'),
    GET_CMS_BLOCK_BY_ID: 'api/rest/cms/block',
    GET_CMS_PAGE_BY_ID: 'api/rest/cms/page',
    GET_EXAM_LINK: formatString.bind(null, 'exam/exam/{{id}}/link'),
    GET_ORDER_LAST: 'api/rest/v2/order/last',
    GET_QUOTE: 'optimaxcart/react/getQuote',
    GET_QUOTE_LOG: 'bff/logs/getQuote',
    GET_REGIONS: formatString.bind(null, `directory/country/{{country}}/region`),
    HOOX_OFFER: '/api/v1/hoox/offer',
    LOAD_QUOTE_BY_TOKEN: '/api/rest/optimaxcheckout/v2/cart/loadQuote',
    NEWSLETTER_SUBSCRIPTION_INFO: '/newsletter/subscriber/info',
    ORDER_GET_ITEMS: formatString.bind(null, 'api/rest/order/{{order}}/items'),
    ORDER_GET_PREVIOUS: formatString.bind(null, 'api/rest/order/{{order}}/previous/last'),
    PAYMENT_GET_REVIEW_DATA: 'optimaxcheckout/payment/reviewData',
    PAYMENTS_OS_SETTINGS: 'payments-os/settings',
    PAYPAL_TOKEN: 'payment/paypal',
    PAYPAL_UPDATE: formatString.bind(null, 'payment/paypal/{{id}}'),
    PRIMER_CREATE_TOKEN: 'api/rest/optimaxcheckout/v2/primer/session',
    PRIMER_DECLINE_REASON: formatString.bind(null, `payment/primer/{{id}}/decline-message`),
    PRIMER_PREVALIDATE_ORDER: '/api/rest/optimaxcheckout/v2/prevalidate',
    QUICKLOOK_GET: 'glassescatalog/react_product/simple/productId',
    REMOVE_COUPON: 'optimaxcart/react/removeCoupon',
    REMOVE_QUOTE_ITEM: 'optimaxcart/react/removeItem/id',
    SAVE_ADDRESS: 'optimaxcheckout/address/save',
    SHIPPING_PROTECTION: '/api/rest/optimaxcheckout/v2/protection',
    SMS_SUBSCRIPTION: '/newsletter/v2/sms/subscribe',
    SMS_SUBSCRIPTION_DELAY: '/newsletter/sms/subscribe/delay',
    SUBSCRIBE: 'newsletter/v2/email/subscribe',
    SUBSCRIPTION_CONSENT_SAVE: 'api/rest/subscription/consent',
    SUBSCRIPTION_STATUS: '/newsletter/v2/subscriptions/status',
    SUCCESS_PAGE_CONFIRM_ORDER: formatString.bind(null, 'api/rest/sales/order/{{orderId}}'),
    UHC_CHANGE_ALLOWANCE_ITEM: 'api/rest/uhc/item',
    UPSELL_ADD_FRAME: 'optimaxcart/upsell/addToCart',
    UPSELL_ADD_FROM_SUCCESS_PAGE: 'checkout/onepage_upsell/add',
    UPSELL_GET_FROM_SUCCESS_PAGE: 'checkout/onepage_upsell',
    VERIFY_EMAIL: '/newsletter/email/verify',
};
